import { Link, useNavigate } from 'react-router-dom'

import { Button } from '@/components/ui/button'
import Card from './Card'

interface Props {
  team: wowaudit.TeamReference
}

const TeamCard = ({ team }: Props) => {
  const navigate = useNavigate()

  return (
    <Card key={team.id}>
      <div>
        <Link
          to={team.ownerReference.defaultPath}
          className='hover:text-primary transition-colors'
        >
          {team.ownerReference.name}
        </Link>
        <span> - </span>
        <Link to={team.path} className='hover:text-primary transition-colors'>
          {team.name}
        </Link>
      </div>
      <div className='flex items-center justify-between'>
        <span className='italic opacity-70'>
          {team.characterAmount} characters
        </span>

        <Button
          variant='outline'
          size='xs'
          onClick={() =>
            navigate(team.path, {
              state: {
                teamReference: team,
                guildReference: team.ownerReference,
              },
            })
          }
        >
          view
        </Button>
      </div>
    </Card>
  )
}

export default TeamCard
